import { useResetRecoilState } from 'recoil'

import * as paymentsAtoms from 'src/atoms/payments'

export const useCloseAndResetSubscriptionModal = () => {
  const resetSubscriptionModalOpen = useResetRecoilState(paymentsAtoms.subcribeModalOpen)
  const resetSelectedPaymentPlan = useResetRecoilState(paymentsAtoms.selectedPaymentPlan)
  const resetUpdateSubscriptionStep = useResetRecoilState(paymentsAtoms.subscriptionUpdateStep)

  return () => {
    resetSubscriptionModalOpen()
    resetSelectedPaymentPlan()
    resetUpdateSubscriptionStep()
  }
}
